export const server = "https://et-srose.vercel.app/api/v1";

export const nif = "4001526922";
export const RC = "6455120";
export const phoneNumber = "(+257) 69 26 24 17";
